<template>
  <reg-card variant="orange">
    <div class="card-icon">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
        <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
        <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
      </svg>
    </div>
    <h2 class="title">{{ avenca.nome }}</h2>
    <p class="price">+{{ avenca.preco_mensal }}€<span>/mês*</span></p>
    <ul class="features">
      <li v-for="(f, i) in avenca.features" :key="i">{{ f }}</li>
    </ul>
    <p class="nota">{{ avenca.nota }}</p>
    <button class="btn-dark" @click="$emit('done', true)">AVANÇAR COM AVENÇA</button>
    <button class="btn-ghost" @click="$emit('done', false)">AVANÇAR SEM AVENÇA</button>
  </reg-card>
</template>

<script>
import RegCard from "../components/RegCard.vue";
export default {
  name: "OStep4",
  components: { RegCard },
  props: {
    avenca: { type: Object, required: true },
  },
};
</script>

<style scoped lang="scss">
.card-icon { width: 36px; height: 36px; background: rgba(255,255,255,.2); border-radius: 10px; display: flex; align-items: center; justify-content: center; margin-bottom: 12px; }
.title  { font-size: 22px; font-weight: 800; color: #fff; margin-bottom: 4px; }
.price  { font-size: 26px; font-weight: 800; color: #fff; margin-bottom: 14px; span { font-size: 14px; font-weight: 500; opacity: .75; } }
.features { list-style: none; padding: 0; margin: 0 0 10px; li { padding: 10px 0; border-bottom: 1px solid rgba(255,255,255,.2); font-size: 13.5px; color: #fff; &:last-child { border-bottom: none; } } }
.nota   { font-size: 11px; color: rgba(255,255,255,.6); margin-bottom: 4px; }
.btn-dark { display: flex; align-items: center; justify-content: center; width: 100%; height: 50px; border: none; border-radius: 10px; background: #1a1210; color: #fff; font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit; margin-top: 16px; &:hover { background: #2d2420; } }
.btn-ghost { display: flex; align-items: center; justify-content: center; width: 100%; height: 50px; border: none; border-radius: 10px; background: rgba(255,255,255,.2); color: #fff; font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit; margin-top: 10px; &:hover { background: rgba(255,255,255,.3); } }
</style>
